import React, { useEffect, useRef, useState } from "react";
import useAutosizeTextArea from "../hooks/useAutosizeTextArea";

const AutosizeTextarea = ({
  classnames,
  name,
  value,
  handleChange,
  placeholder,
  setFocused,
  initialRows,
  editing,
}) => {
  const onFocus = () => {
    setFocused(true);
  };
  const onBlur = () => {
    setTimeout(() => {
      setFocused(false);
    }, 200);
  };
  const textAreaRef = useRef(null);
  useAutosizeTextArea(textAreaRef.current, value);
  useEffect(() => {
    if (editing && textAreaRef.current) {
      const textarea = textAreaRef.current;
      textarea.focus();
      textarea.setSelectionRange(textarea.value.length, textarea.value.length);
    }
  }, [editing]);
  return (
    <textarea
      className={classnames}
      name={name}
      onChange={handleChange}
      placeholder={placeholder}
      ref={textAreaRef}
      rows={initialRows}
      value={value}
      onFocus={onFocus}
      onBlur={onBlur}
    />
  );
};

export default AutosizeTextarea;
